import { useEffect } from 'react';

/**
 * Highlights nav links when their section is in view (matches static script.js).
 */
export function useActiveNav() {
  useEffect(() => {
    const sections = document.querySelectorAll('section[id]');
    const navAnchors = document.querySelectorAll('.nav-links a[href^="#"]');

    if (!('IntersectionObserver' in window) || !sections.length || !navAnchors.length) {
      return undefined;
    }

    const setActive = (id) => {
      navAnchors.forEach((a) => {
        const href = a.getAttribute('href');
        a.classList.toggle('active', href === `#${id}`);
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-45% 0px -50% 0px', threshold: 0 }
    );

    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);
}
